<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" :val="headerTitle"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <section class="full hr mg0">
          <div class="banner">
            <span class="img">
              <img src="@/../static/img/mw/content/mybef_banner2.png" alt="" />
            </span>
          </div>
        </section>

        <section class="benefitCont hr">
          <ul class="benefitList">
            <li v-for="(boardBenefit, index) in boardBenefits" :key="index">
              <div class="bnfcon1">
                <span class="img">
                  <img :src="boardBenefit.imgURL" />
                </span>
                <span class="tag">{{ boardBenefit.serveType }}</span>
                <span class="item">{{ boardBenefit.orderName }}</span>
                <span class="tit" v-html="boardBenefit.benefitName"></span>
                <span class="copy" v-html="boardBenefit.benefitDesc"></span>
                <span class="desc">{{ boardBenefit.benefitDescSub }}</span>
              </div>
            </li>
          </ul>
        </section>

        <CommonBanner></CommonBanner>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import ApiService from '@/common/api.service';
import CommonBanner from '@/components/banner/CommonBanner';

export default {
  name: 'benefitsWelmallBenefits',
  components: {
    CommonBanner,
  },
  data: function() {
    return {
      headerTitle: '웰몰 혜택 안내',
      boardBenefits: {},
    };
  },
  mounted() {
    this.selectBoardBenefits();
  },
  methods: {
    selectBoardBenefits() {
      ApiService.service('GET', '/board/benefits', '')
        .then(({ data }) => {
          console.log(data);
          this.boardBenefits = data.result;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
  },
};
</script>
